/**
 * Restore a historical card version.
 * AppSync: `restoreCardVersion(cardId: ID!, version: Int!, revisions: Int!): CardItem`
 */
export const mutationRestoreCardVersion = `mutation restoreCardVersion($cardId: ID!, $version: Int!, $revisions: Int!) {
  restoreCardVersion(cardId: $cardId, version: $version, revisions: $revisions) {
    cardId
    title
    subtitle
    cardType
    chartType
    paletteId
    data {
      metrics {
        id
        name
        label
        dataType
        aggregation
      }
      dimensions {
        id
        name
        label
        dataType
      }
    }
    visualization
    style {
      card {
        padding
        contentAlignment
      }
      colors {
        light {
          card {
            background
            border
            shadow
          }
        }
        dark {
          card {
            background
            border
            shadow
          }
        }
      }
    }
    icon
    image
    revisions
    dateUpdated
  }
}`;

/** GraphQL variables for {@link mutationRestoreCardVersion}. */
export interface RestoreCardVersionVariables {
	cardId: string;
	/** Version to restore (1 to current revisions) */
	version: number;
	/** Current revision for optimistic locking */
	revisions: number;
}
